import React from "react"

export default function DiffusionAdCardFolder({ folderName, folderId, onClick }) {
  return (
    <div className="m-3" onClick={() => onClick(folderId)}>
      <button type="button" className="btn btn-block btn-light p-0">
        <div className="info-box bg-transparent mb-0 p-0">
          <div className="info-box-content">
            <div className="d-flex justify-content-between">
              <span style={{ maxWidth: "60%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {folderId ? (
                  folderId === "canva" ? (
                    <img src="/dist/img/Canva_Icon_logo_256x256.png" alt="Canva Logo" width={"16px"} height={"16px"} />
                  ) : (
                    <i className="fas fa-folder"></i>
                  )
                ) : (
                  <i className="fas fa-chevron-left"></i>
                )}{" "}
                <b>{folderName}</b>
              </span>
              <span>
                <em>Dossier</em>
              </span>
            </div>
          </div>
        </div>
      </button>
    </div>
  )
}
